import { SendMailParams } from "./models/mail";
import { environment as env } from '../environments/environment';

export const productionTitle = 'Nevermore' as const
const crewtimeLink = 'https://nevermore.crewtime.app' as const
const financeEmail = 'nevermore.finance@protoncinema.hu' as const
const pmEmail = 'csogeg@gmail.com' as const
export const invoiceMainualLink = 'https://drive.google.com/file/d/1jh6Jp8iOWv7-5UZppQyR2k9NpuAavtJw/view?usp=sharing' as const 
/** Terms & Conditions */
export const generalTCLink = '' as const
export const PRIVACY_POLICY_LINK = 'https://drive.google.com/file/d/1qZR5Ze1VmVhDiFo_H8-1XriuxahfeOI6/view?usp=drive_link' as const

export const config = {
    dev: { name: "SÓS András", email: 'sosandris@gmail.com' },
    /** Ha ezek a userek közül van valaki bejelentkezve, 
     * akkor email küldés előtt kérdezz rá, hogy biztos ki akarja-e küldeni. 
     * Jó eséllyel csak tesztelgetünk, és nem akarjuk ténylegesen elküldeni az emailt. */
    DONT_SEND_MAIL: [/^sosandris@gmail.com$/, /@tu.tu$/, /^sergeikov@gmail.com$/, /^zoltantokey@gmail.com$/],
    SHOW_GROWING_OTTA_RATE: false,
    CONFIG_PERSONAL_END_DATES: true,
    AUTOFILL_CONTRACT_DATES: true,
    HAS_FOREIGN_CREW: false,
    ALLOW_TRAVELDAY: false as boolean | 'onlyForMoreThanDeptHead',

    ALLOW_CREW_MEMBER_EDIT_FEES: true,
    HIDE_FEES_IF_HAS_INVOICE_CONTACT: false,
    DISABLE_OLD_TS: true,
    DISABLE_OLD_TS_OT: true,
    DISABLE_OLD_TS_PREP_WEEKS: 2 as false | number,
    DISABLE_OLD_TS_SHOOTING_WEEKS: 2 as false | number,
    DISPLAY_CALC_FEES_BEFORE_SUBMIT_TS: true,
    ALLOW_CREW_MEMBER_EDIT_OT_FEE: false,
    ALLOW_CREW_MEMBER_EDIT_OT_STEP: false,
    ALLOW_CREW_MEMBER_EDIT_TA_FEE: false,
    ALLOW_CREW_MEMBER_EDIT_CONTRACT_DATES: true,
    ALLLOW_CONTRACT_END_DATE: true,
    ALLOW_PERDIEM: true as boolean | 'onlyForMoreThanDeptHead',
    ALLOW_OT_PERCENT: true,
    OT_PERCENT: 10,
    ALLOW_TA_PERCENT: true,
    TA_PERCENT: 15,
    MAX_ALLOWED_OTTA_PERCENT: 25,
    ALLOW_REST_DAY: false as boolean | 'onlyForMoreThanDeptHead',
    ALLOW_WORK_ON_REST_DAY: false,
    PERDIEM_MULTIPLIER_FOR_REST_DAY: 1,
    HUF_PER_KM: 75,
    REPORT: {
        CURRENCY: 'USD' as string | undefined,
    },
    
    /** 'fixed-rates': Nem adható meg naponta új árfolyam. Ha több mint 2 pénznem van, akkor csak ez választható, mert a napi árfolyam mentésekor nem adható meg, hogy melyik pénznam árfolyamát mented */
    MULTIPLE_CURRENCIES: 'fixed-rates' as 'fixed-rates' | boolean,

    DISABLED_TS_HISTORY_TEXT: 'Letiltva',
    UPLOAD_ALLOW_FILETYPES: ["pdf"], //["pdf", "jpg", "jpeg", "png", "tiff"],
    
    HU: {
        CONTRACT: {
            ENABLE_FILTER_FINANCE_APPROVED: true,
            CONTRACT_GEN_FEATURE: true,
            ALLOW_PROD_MGR_APPROVE_UNSUBMITTED_CONTRACT: true,
            SEND_MAIL_FOR_SENDBACK_TO_CREW: {
                ccTo: pmEmail,
                subject: `[${productionTitle}] Start Form visszaküldve`,
                body: `Kedves {USERNAME}!<br><br>A Start Formodat {FROM_USER} visszaküldte javításra. Kérlek, javítsd ki a hibákat, és küldd be újra a ${crewtimeLink} címen.`,
                bodyEnding: '<br><br>Köszönjük!<br>CrewTime',
            },
            SEND_MAIL_FOR_APPROVED: {
                enabled: false,
                sendTo: financeEmail,
                subject: `[${productionTitle}] Start Form elfogadva`,
                body: `Kedves Andi!<br><br>A következő Start Formot jóváhagyták: {START_FORM}. Megtekintheted a ${crewtimeLink} címen.<br><br>Üdvözlettel!<br>CrewTime`,
            },
            SEND_MAIL_FINANCE_NOTIF_NEW_POSITION: {
                enabled: false,
                sendTo: financeEmail,
                subject: `[${productionTitle}] Új pozíció jóváhagyva`,
                body: `Sziasztok! <br><br> A következő Start Formot új pozícióval, de megegyező céggel jóváhagyták: {START_FORM}. Megtekintheted a ${crewtimeLink} címen.<br><br>Üdvözlettel!<br>CrewTime`,
            }
        },
        USER: {
            SEND_MAIL_FOR_REG_ACCEPTED: {
                subject: `[${productionTitle}] Regisztráció elfogadva`,
                body: `Kedves {USERNAME}!<br><br>A regisztrációdat elfogadtuk. Kérlek, töltsd ki a start formodat a ${crewtimeLink} címen.<br><br>Köszönjük!<br>CrewTime`,
            },
        },
        TS: {
            SEND_MAIL_FOR_SENDBACK_TO_CREW: {
                ccTo: pmEmail,
                subject: `[${productionTitle}] Timesheet visszaküldve`,
                body: `Kedves {USERNAME}!<br><br>A {TS_START_DATE}-i Timesheetedet {FROM_USER} visszaküldte javításra. Kérlek, javítsd ki a hibákat, és küldd be újra a ${crewtimeLink} címen.`,
                bodyEnding: '<br><br>Köszönjük!<br>CrewTime',
            },
            /** timeFromCrewCallFirstValueableOtRate: a crew calltól számított x idő után jár egy egyösszegű díj. Az összeg az első órára járó túlóra díjával egyezik meg
             * Az összeg az első órára járó túlóra díjával egyezik meg
             * setAtProdDeptSf: A produkció / részleg start formján beállított összeg kerül kiszámolásra
             * false: nem jár senkinek
             */
            MEAL_PENALTY: 'setAtProdDeptSf' as 'firstValueableOtRate' | 'setAtProdDeptSf' | 'timeFromCrewCallFirstValueableOtRate' | false,
        // MEAL_PENALTY: false as 'firstValueableOtRate' | 'setAtProdDeptSf' | 'timeFromCrewCallFirstValueableOtRate' | false,
            /** A Crew Calltól számított hány óó:pp után kapja a MEAL_PENALTY-t
             * Csak ha a timeFromCrewCall van beállítva a MEAL_PENALTY-nek */
            MEAL_PENALTY_START_AFTER_CREW_CALL: '6:15',
            /** A start formban megjelenő label szöveg. Ha null, akkor a dictionary-ből jön ("meal-penalty-label"-> Meal Penalty egy teljes órára) */
            MEAL_PENALTY_SF_LABEL: 'Meal Penalty' as null | string,
            DISPLAY_KM_PARKING_VIGN_IN_CALCULATED_SECTION: true,
            // Ha nem kell pénzügyes jóváhagyás, akkor , 
            ALLOW_SUBMIT_BEFORE_APPROVAL: false,
            WARN_NUM_CONSEQ_DAYS: 6 as number | false,
            HIDE_KM_FEE: false,
            /** Mikor mutassuk, hogy hány TS lett összesen leadva
             * false: soha,
             * true: mindig,
             * 'onlyWhenPlannedDaysFilledOut': csak akkor, ha ki van töltve a tervezett napok száma (f_numPlannedDays) */
            DISPLAY_NUM_TS: false as boolean | 'onlyWhenPlannedDaysFilledOut',
            DISPLAY_SUM_DAYS: true,
        },
    },
} as const

export const IS_RAGE = (productionTitle as unknown == 'RAGE' as const)
export const IS_DENNIS = (productionTitle as unknown == 'Dennis' as const)
    || (productionTitle as unknown == 'Nevermore' as const)